import { render, staticRenderFns } from "./Anomaly.vue?vue&type=template&id=ba976816&scoped=true&"
import script from "./Anomaly.vue?vue&type=script&lang=js&"
export * from "./Anomaly.vue?vue&type=script&lang=js&"
import style0 from "./Anomaly.vue?vue&type=style&index=0&id=ba976816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba976816",
  null
  
)

export default component.exports